/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { BankAccount } from './bank-account';

/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 유저 uuid
     * @type {string}
     * @memberof User
     */
    'userUuid': string;
    /**
     * 아이디
     * @type {string}
     * @memberof User
     */
    'id': string;
    /**
     * 비밀번호
     * @type {string}
     * @memberof User
     */
    'password': string;
    /**
     * 닉네임
     * @type {string}
     * @memberof User
     */
    'nickname': string;
    /**
     * 이름
     * @type {string}
     * @memberof User
     */
    'name': string;
    /**
     * 전화번호
     * @type {string}
     * @memberof User
     */
    'phone': string;
    /**
     * 성별
     * @type {string}
     * @memberof User
     */
    'gender': UserGenderEnum;
    /**
     * 생년월일
     * @type {string}
     * @memberof User
     */
    'birthdate': string;
    /**
     * 프로필 사진
     * @type {string}
     * @memberof User
     */
    'profileImg': string;
    /**
     * 외국인 여부
     * @type {boolean}
     * @memberof User
     */
    'isForeigner': boolean;
    /**
     * 주민등록번호 뒷자리
     * @type {string}
     * @memberof User
     */
    'rrn'?: string;
    /**
     * ci (모든 유저들이 가지고 있어야 함)
     * @type {string}
     * @memberof User
     */
    'ci': string;
    /**
     * di (레거시 뷰업 유저들이 가지고 있음)
     * @type {string}
     * @memberof User
     */
    'di': string;
    /**
     * 유저 레벨
     * @type {string}
     * @memberof User
     */
    'level'?: UserLevelEnum;
    /**
     * 유저 레벨 진행 퍼센트
     * @type {number}
     * @memberof User
     */
    'levelProgress'?: number;
    /**
     * 서포터즈 여부
     * @type {boolean}
     * @memberof User
     */
    'isSupporter'?: boolean;
    /**
     * 수호신 여부
     * @type {boolean}
     * @memberof User
     */
    'isGuardian'?: boolean;
    /**
     * 관리자의 해당 유저 즐겨찾기 여부
     * @type {boolean}
     * @memberof User
     */
    'isStarred'?: boolean;
    /**
     * 관리자의 해당 유저 차단 여부
     * @type {boolean}
     * @memberof User
     */
    'isBanned'?: boolean;
    /**
     * 관리자의 유저 메모
     * @type {string}
     * @memberof User
     */
    'memo': string;
    /**
     * 현재 유저의 총 포인트
     * @type {number}
     * @memberof User
     */
    'totalPoint'?: number;
    /**
     * 환급 가능한 포인트
     * @type {number}
     * @memberof User
     */
    'exchangeablePoint'?: number;
    /**
     * 총 환급 포인트
     * @type {number}
     * @memberof User
     */
    'totalExchangedPoint'?: number;
    /**
     * 누적 획득 총 포인트
     * @type {number}
     * @memberof User
     */
    'earnedPoint'?: number;
    /**
     * 회원가입 경로
     * @type {string}
     * @memberof User
     */
    'registerPath': UserRegisterPathEnum;
    /**
     * 관리자 레벨 변경 여부
     * @type {boolean}
     * @memberof User
     */
    'isLevelChanged'?: boolean;
    /**
     * 최종 접속 일시
     * @type {string}
     * @memberof User
     */
    'lastAccessedAt': string;
    /**
     * 생성 일시
     * @type {string}
     * @memberof User
     */
    'createdAt': string;
    /**
     * 수정 일시
     * @type {string}
     * @memberof User
     */
    'updatedAt': string;
    /**
     * 계좌
     * @type {Array<BankAccount>}
     * @memberof User
     */
    'bankAccounts': Array<BankAccount>;
}

export const UserGenderEnum = {
    M: 'M',
    F: 'F',
    Unknown: 'unknown'
} as const;

export type UserGenderEnum = typeof UserGenderEnum[keyof typeof UserGenderEnum];
export const UserLevelEnum = {
    Baby: 'baby',
    Friends: 'friends',
    Family: 'family',
    Supporters: 'supporters',
    Guardian: 'guardian',
    Both: 'both'
} as const;

export type UserLevelEnum = typeof UserLevelEnum[keyof typeof UserLevelEnum];
export const UserRegisterPathEnum = {
    FriendlyRecommend: 'friendlyRecommend',
    Search: 'search',
    Naver: 'naver',
    Youtube: 'youtube',
    Instagram: 'instagram',
    Facebook: 'facebook',
    Other: 'other'
} as const;

export type UserRegisterPathEnum = typeof UserRegisterPathEnum[keyof typeof UserRegisterPathEnum];


